import {$, hide, show} from "./Dom.ts";
import {keysMatch} from "./WePush.ts";

document.addEventListener('DOMContentLoaded', () => {
    if (document.body.dataset.url === 'parametre_notification_messagerie') {
        const pushactif = window.Openscop?.pushactif;
        let endpoints = window.Openscop?.push_endpoints;
        if (typeof endpoints === 'string') {
            try {
                endpoints = JSON.parse(endpoints);
            } catch {
                endpoints = {point: []};
            }
        }

        const subBtn = $<HTMLButtonElement>('#webpush-subscribe-button');
        if (!subBtn) return;

        const serviceWorkerMeta = $<HTMLMetaElement>('meta[name="service-worker-js"]');
        if (!serviceWorkerMeta || !('serviceWorker' in navigator) || !('PushManager' in window)) {
            show($<HTMLElement>('#alert_notif_push'));
            subBtn.innerText = 'Notifications Push non supportées';
            subBtn.disabled = true;
            return;
        }

        const serviceWorker = serviceWorkerMeta.content;
        navigator.serviceWorker.register(serviceWorker)
            .then(async (reg) => {
                const testBtn = $<HTMLButtonElement>('#webpush-test-button');
                try {
                    const nav = await reg.pushManager.getSubscription();
                    let ok = 0;
                    const metaVapid = $<HTMLMetaElement>('meta[name="django-webpush-vapid-key"]');
                    const currentVapidKey = metaVapid?.content;

                    if (nav) {
                        if (currentVapidKey && nav.options?.applicationServerKey) {
                            if (!keysMatch(nav.options.applicationServerKey, currentVapidKey)) {
                                console.warn("La souscription du navigateur utilise une ancienne clé VAPID. Désabonnement automatique.");
                                await nav.unsubscribe();
                            } else {
                                const navpoint = nav.endpoint;
                                if (pushactif === 1 && endpoints && Array.isArray(endpoints.point)) {
                                    for (let i = 0; i < endpoints.point.length; i++) {
                                        if (endpoints.point[i] === navpoint) {
                                            ok = 1;
                                            break;
                                        }
                                    }
                                }
                            }
                        } else {
                            await nav.unsubscribe();
                        }
                    }

                    if (ok === 1) {
                        subBtn.innerText = 'Se désabonner des notifications Push';
                        subBtn.disabled = false;
                        window.isPushEnabled = true;
                        if (testBtn) show(testBtn);
                    } else {
                        subBtn.innerText = 'Abonnez-vous aux notifications Push';
                        subBtn.disabled = false;
                        window.isPushEnabled = false;
                        if (testBtn) hide(testBtn);
                        show($<HTMLElement>('#alert_notif_push'));
                    }
                } catch {
                    if (testBtn) hide(testBtn);
                    subBtn.innerText = 'Abonnez-vous aux notifications Push';
                    subBtn.disabled = false;
                    window.isPushEnabled = false;
                    show($<HTMLElement>('#alert_notif_push'));
                }
            })
            .catch(() => {
                show($<HTMLElement>('#alert_notif_push'));
                subBtn.innerText = 'Abonnez-vous aux notifications Push';
                subBtn.disabled = false;
            });
    }
});